import { atom } from 'recoil';
import { ITelefone } from '../../commons/types/usuatios';


export const telefonesAtom = atom<ITelefone[]>({
  key: 'telefones', 
  default: [] as ITelefone[],
}); 
